import { defineStore } from 'pinia'
import storage from '@/utils/storage'
import storeStorage from '@/stores/modules/storeStorage'
import { login } from '@/api/oauth.js'
import { setRefreshToken, setToken } from '@/utils/auth.js'
import { getUser } from '@/api/user.js'

export const useUserStore = defineStore('user', {
  state: () => ({
    userInfo: {},
    scope: '1'
  }),
  actions: {
    async login(userForm) {
      try {
        const res = await login(userForm).catch(err => {
          let res = err.response
          if (!res) return
          if (res.status === 400 || res.status === 401) {
            const errorMap = {
              unauthorized: 40001,
              'Bad credentials': 40002,
              invalid_grant: res.data.error_description === 'Bad credentials' ? 40002 : 40003
            }
            return {
              code: !res.data ? 40001 : errorMap[res.data.error] || errorMap[res.data.error_description] || 40001
            }
          }
        })

        if (res && Object.hasOwnProperty.call(res, 'access_token')) {
          if (res.status !== 1) {
            return {
              code: 20001
            }
          }

          setToken(res.access_token)
          setRefreshToken(res.refresh_token)

          let versionInfo = res.versionInfo || {}
          versionInfo.validStartDate = res.validStartDate || ''
          versionInfo.validEndDate = res.validEndDate || ''

          let role = res.role
          if (res.email === 'admin2@airenz.com') {
            role = 2
          }

          this.userInfo = {
            id: res.id,
            fullName: res.firstName + ' ' + res.lastName,
            firstName: res.firstName,
            lastName: res.lastName,
            userName: res.userName,
            email: res.email,
            role: role,
            status: res.status,
            versionInfo: versionInfo,
            mobile: res.mobile,
            timeZone: res.timeZone,
            countryId: res.countryId
          }
          this.scope = res.scope

          return new Promise(resolve => {
            resolve({
              code: 10000
            })
          })
        } else {
          return res
        }
      } catch {
        this.reset()
        storage.clear()
        storage.clear('storage')

        return {
          code: 9999,
          msg: ''
        }
      }
    },
    // 获取用户信息 更新用户数据
    async getUserInfo() {
      const res = await getUser({})
      if (res.code === 10000) {
        let versionInfo = res.data.versionInfo || {}
        versionInfo.validStartDate = res.data.validStartDate || ''
        versionInfo.validEndDate = res.data.validEndDate || ''
        // 兼容 versionName 在 data 顶层的情况
        if (!versionInfo.versionName && res.data.versionName) {
          versionInfo.versionName = res.data.versionName
        }

        const userInfo = {
          id: res.data.id,
          fullName: res.data.firstName + ' ' + res.data.lastName,
          firstName: res.data.firstName,
          lastName: res.data.lastName,
          userName: res.data.userName,
          email: res.data.email,
          role: res.data.role,
          status: res.data.status,
          versionInfo: versionInfo,
          mobile: res.data.mobile,
          timeZone: res.data.timeZone,
          countryId: res.data.countryId,
          promptCount: res.data.promptCount
        }
        this.userInfo = userInfo
      }
    },

    setUser(data) {
      this.userInfo = data
    },
    setScope(scope) {
      this.scope = scope
    },

    reset() {
      this.$reset()
    }
  },
  persist: {
    enabled: true,
    strategies: [
      {
        storage: storeStorage
      }
    ]
  }
})

export default useUserStore
